export class CompanyTime{
    startHours: number = null;
    startMinutes: number = null;
    endHours: number = null;
    endMinutes: number = null;
}